import React from 'react';
import {openQuickSearch} from "../../navigation/actions/open-quick-search";
import openAdvancedSearch from "../../navigation/actions/open-advanced-search";

type Props = {
    message?: string
}

export default function MenuSearch_NoResults(props: Props) {

    const renderMessage = ()=> {
        const message = props.message ? props.message : 'No results found in this space.'

        return (
            <div className="ui5-txt-no-accent-small t-a-center m-t-20 p-h-15">
                {message}
            </div>
        )
    }

    return (
        <div className="flex-column-center-center h-300">
            <div className="isvg-search-empty w-130 min-h-76"/>

            {renderMessage()}

            <div className="ui5-txt-no-accent-small m-t-15 p-h-15 lh-14em t-a-center">
                Use

                <span className="ui5-txt-link-small m-l-3 m-r-3" onClick={openQuickSearch}>Quick Search</span>

                or

                <span className="ui5-txt-link-small m-l-3 m-r-3"
                      onClick={openAdvancedSearch}>Advanced Search </span>

                to find items across entire organization.
            </div>
        </div>
    )
}
